import { render } from "./RoomDisplay.vue?vue&type=template&id=57164c0f&scoped=true"
import script from "./RoomDisplay.vue?vue&type=script&lang=js"
export * from "./RoomDisplay.vue?vue&type=script&lang=js"

import "./RoomDisplay.vue?vue&type=style&index=0&id=57164c0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57164c0f"]])

export default __exports__